import useToast from "@/contexts/toast-context";
import { isError } from "@/helpers/error-helpers";
import useLoading, { UseLoadingReturn } from "@/hooks/use-loading";
import { IRecoverPassword } from "@/interfaces/auth.interfaces";
import authService from "@/services/auth.service";
import { clearRecoverPasswordEmailState } from "@/states/recover-password-email";
import { RequestsProps } from "@/types/requests.types";

export type RecoverPasswordProps = {
  formData: IRecoverPassword;
} & RequestsProps;
export type UseRecoverPasswordReturn = {
  recoverPassword: (props: RecoverPasswordProps) => Promise<void>;
} & UseLoadingReturn;

const useRecoverPassword = (): UseRecoverPasswordReturn => {
  const { isLoading, startLoading, endLoading, loadingIcon } = useLoading();
  const { showToast } = useToast();

  const recoverPassword = async ({
    formData,
    onSuccess,
    onError,
  }: RecoverPasswordProps): Promise<void> => {
    startLoading();
    try {
      await authService.recoverPassword(formData);

      clearRecoverPasswordEmailState();
      if (onSuccess) onSuccess();
    } catch (e) {
      const message = isError(e) ? e.response?.data.messages[0] || e.message : "";
      showToast({ text: message, type: "error" });
      if (onError) onError();
    } finally {
      endLoading();
    }
  };

  return {
    isLoading,
    startLoading,
    endLoading,
    loadingIcon,
    recoverPassword,
  };
};

export default useRecoverPassword;
